/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"

import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import SikutyosonSearchModal from "../../../components/SearchModal/SikutyosonSearchModal"
import { T都道府県 } from "../../../service/master/todohuken/TTodohuken"
import TumiorosisakiService from "../../../service/master/tumiorosisaki/tumiorosisakiService"
import {
  tumiorosisakiPostReqSchema,
  tumiorosisakiPutReqSchema,
} from "../../../service/master/tumiorosisaki/tumiorosisakiScheme"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import {
  TTumiorosisakiPostReq,
  TTumiorosisakiPutReq,
  T積卸先,
} from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import RequiredMark from "../../../components/RequiredMark"
import Spinner from "../../../components/Spinner"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import ComboBox from "../../../components/ComboBox"
import TodohukenService from "../../../service/master/todohuken/todohukenService"
import { T市区町村 } from "../../../service/master/sikutyoson/TSikutyoson"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import { RootState } from "../../../globalStore/rootreducer"
import { メニューコード } from "../../../constant/menuCode"
import ContentService from "../../../service/content/contentService"
import saveAs from "file-saver"

/**
 * 積卸先マスタ
 * @returns
 */
const MasterTumiorosisakiRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.積卸先マスタ登録
      )?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [積卸先コード, set積卸先コード] = useState<string>()
  const [積卸先名, set積卸先名] = useState<string>()
  const [積卸先名カナ, set積卸先名カナ] = useState<string>()
  const [積卸先略称, set積卸先略称] = useState<string>()
  const [住所２, set住所2] = useState<string>()
  const [住所３, set住所3] = useState<string>()
  const [郵便番号, set郵便番号] = useState<string>()
  const [電話番号, set電話番号] = useState<string>()
  const [FAX番号, setFAX番号] = useState<string>()

  const [都道府県コード, set都道府県コード] = useState<string | null>()
  const [都道府県, set都道府県] = useState<T都道府県 | null>()
  const [積卸先担当者, set積卸先担当者] = useState<string>()

  const [客先台帳ファイル名, set客先台帳ファイル名] = useState<string>()
  const [客先台帳ファイルURL, set客先台帳ファイルURL] = useState<string>()

  const [新規客先台帳ファイル名, set新規客先台帳ファイル名] = useState<string>()
  const [新規客先台帳ファイル, set新規客先台帳ファイル] = useState<File>()

  const [最終更新日時, set最終更新日時] = useState<string>()
  const [最終更新ID, set最終更新ID] = useState<string>()
  const [廃止日, set廃止日] = useState<string>()

  //　エラー表示用フラグ
  const [isInvalid荷主コード, setIsInvalid荷主コード] = useState<boolean>(false)
  const [isInvalid積卸先コード, setIsInvalid積卸先コード] = useState<boolean>()
  const [isInvalid積卸先名, setIsInvalid積卸先名] = useState<boolean>(false)
  const [isInvalid積卸先名カナ, setIsInvalid積卸先名カナ] =
    useState<boolean>(false)
  const [isInvalid積卸先略称, setIsInvalid積卸先略称] = useState<boolean>(false)
  const [isInvalid都道府県コード, setIsInvalid都道府県コード] =
    useState<boolean>(false)
  const [isInvalid住所2, setIsInvalid住所2] = useState<boolean>(false)
  const [isInvalid住所3, setIsInvalid住所3] = useState<boolean>(false)
  const [isInvalid郵便番号, setIsInvalid郵便番号] = useState<boolean>(false)
  const [isInvalid電話番号, setIsInvalid電話番号] = useState<boolean>(false)
  const [isInvalidFAX番号, setIsInvalidFAX番号] = useState<boolean>(false)
  const [isInvalid積卸先担当者, setIsInvalid積卸先担当者] =
    useState<boolean>(false)
  const [isInvalid客先台帳, setIsInvalid客先台帳] = useState<boolean>(false)
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)
  const [isConfirmHaisiModalShow, setIsConfirmHaisiModalShow] = useState(false)
  const [isConfirmHaisiKaizyoModalShow, setIsConfirmHaisiKaizyoModalShow] =
    useState(false)
  const [is市区町村ModalShow, setIs市区町村ModalShow] = useState(false)
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  // 都道府県ComboBox
  const [都道府県ComboBox, set都道府県ComboBox] = useState<TWijmoComboBox<
    string,
    T都道府県
  > | null>(null)
  const [都道府県ItemSource, set都道府県ItemSource] = useState<T都道府県[]>()
  const [都道府県isLoadEnded, set都道府県isLoadEnded] = useState<boolean>(false)

  // ファイルアップデート用
  const refFileInput = useRef<HTMLInputElement>(null)

  // 社名重複チェック用検索
  const [積卸先名称確認List, set積卸先名称確認List] = useState<T積卸先[]>([])
  const [isSearching, setIsSearching] = useState(false)
  const [searchAbortController, setSearchAbortController] =
    useState<AbortController>()

  // 廃止用ボタン表示フラグ
  const [廃止ボタン表示フラグ, set廃止ボタン表示フラグ] = useState(false)

  //#endregion

  //#region [method]

  const set市区町村 = (value: T市区町村) => {
    set都道府県コード(value?.都道府県コード)
    set住所2(value.市区町村名漢字)
  }

  /**
   * データ取得
   */
  const getData = async (id: number, signal: AbortSignal) => {
    const service = new TumiorosisakiService()
    try {
      const res = await service.get(id, signal)
      if (res.data) {
        // TODO:詰め方をチェック
        set荷主コード(res.data.荷主コード)
        set荷主名(res.data.荷主名)
        set積卸先コード(res.data.積卸先コード)
        set積卸先名(res.data.積卸先名)
        set積卸先名カナ(res.data.積卸先名カナ)
        set積卸先略称(res.data.積卸先略称)
        set都道府県コード(res.data.都道府県コード ?? "")
        set住所2(res.data.住所２)
        set住所3(res.data.住所３)
        set郵便番号(res.data.郵便番号)
        set電話番号(res.data.電話番号)
        setFAX番号(res.data.FAX番号)
        set積卸先担当者(res.data.積卸先担当者)
        set客先台帳ファイル名(res.data.ファイル名)
        set客先台帳ファイルURL(res.data.ファイルURL)
        set最終更新日時(res.data.更新日時)
        set廃止日(res.data.廃止日)
        set最終更新ID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  // 社名チェック用積卸先検索
  const search = async (積卸先名: string) => {
    if (積卸先名.length < 2) {
      searchAbortController?.abort()
      set積卸先名称確認List([])
      return
    }
    setIsSearching(true)

    // 検索が走った場合,前回の検索は止める
    searchAbortController?.abort()
    const newAbortController = new AbortController()
    setSearchAbortController(newAbortController)
    try {
      const res = await new TumiorosisakiService().getList(
        {
          荷主コード,
          積卸先名,
        },
        newAbortController.signal
      )
      set積卸先名称確認List([...res.data])
      setIsSearching(false) // 検索中状態に遷移
    } catch (error) {
      if (newAbortController.signal.aborted) return
      disPatch(setAlerts(error))
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  const fileUpload: React.MouseEventHandler<HTMLElement> = (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (refFileInput && refFileInput.current) {
      refFileInput.current.click()
    }
  }

  const onFileInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.files != null && e.target.files[0]) {
      set新規客先台帳ファイル(e.target.files[0])
      set新規客先台帳ファイル名(e.target.files[0].name)
    }
  }

  const newFileDelete = () => {
    set新規客先台帳ファイル(undefined)
    set新規客先台帳ファイル名(undefined)
  }

  const getPostReq = (): TTumiorosisakiPostReq => {
    return {
      荷主コード: 荷主コード ?? "",
      積卸先コード: 積卸先コード ?? "",
      積卸先名: 積卸先名 ?? "",
      積卸先名カナ: 積卸先名カナ ?? "",
      積卸先略称,
      都道府県コード: 都道府県コード ?? "",
      住所２,
      住所３,
      郵便番号,
      電話番号,
      FAX番号,
      客先台帳ファイル名:
        (新規客先台帳ファイル名 ?? "") !== ""
          ? 新規客先台帳ファイル名!
          : 客先台帳ファイル名 ?? "",
      客先台帳: 新規客先台帳ファイル,
      積卸先担当者,
    }
  }

  const getPutReq = (): TTumiorosisakiPutReq => {
    return {
      荷主コード: 荷主コード ?? "",
      積卸先コード: 積卸先コード ?? "",
      積卸先名: 積卸先名 ?? "",
      積卸先名カナ: 積卸先名カナ ?? "",
      積卸先略称,
      都道府県コード: 都道府県コード ?? "",
      住所２,
      住所３,
      郵便番号,
      電話番号,
      FAX番号,
      客先台帳ファイル名:
        (新規客先台帳ファイル名 ?? "") !== ""
          ? 新規客先台帳ファイル名!
          : 客先台帳ファイル名 ?? "",
      客先台帳: 新規客先台帳ファイル,
      積卸先担当者,
      更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    setIsInvalid客先台帳(false)
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (id) {
      schema = tumiorosisakiPutReqSchema
      data = getPutReq()
    } else {
      schema = tumiorosisakiPostReqSchema
      data = getPostReq()
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)

    // TODO:ファイルに対してはajvではチェックできないため別枠で行う
    let fileError = false
    if (新規客先台帳ファイル != null) {
      let file_type = 新規客先台帳ファイル.name.split(".").pop()?.toLowerCase()
      if (file_type !== "pdf") {
        fileError = true
      }
    }

    if (!validateResult) {
      const errors = validate.errors
      const errorMessages: string[] = []
      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        errorMessages.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
      if (fileError) {
        errorMessages.push("添付できるファイルはpdfのみです。")
        setIsInvalid客先台帳(true)
      }
      disPatch(setWarningAlerts([...errorMessages]))
      return
    } else if (fileError) {
      disPatch(setWarningAlerts(["添付できるファイルはpdfのみです。"]))
      setIsInvalid客先台帳(true)
      return
    }
    setIsConfirmModalShow(true)
  }

  /**
   * 削除送信前
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  /**
   * 廃止送信前
   */
  const beforeHaisiSubmit = () => {
    setIsConfirmHaisiModalShow(true)
  }

  /**
   * 廃止解除送信前
   */
  const beforeHaisiKaizyoSubmit = () => {
    setIsConfirmHaisiKaizyoModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid荷主コード(errorProperties.includes("荷主コード"))
    setIsInvalid積卸先コード(errorProperties.includes("積卸先コード"))
    setIsInvalid積卸先名(errorProperties.includes("積卸先名"))
    setIsInvalid積卸先名カナ(errorProperties.includes("積卸先名カナ"))
    setIsInvalid積卸先略称(errorProperties.includes("積卸先略称"))
    setIsInvalid都道府県コード(errorProperties.includes("都道府県コード"))
    setIsInvalid住所2(errorProperties.includes("住所２"))
    setIsInvalid住所3(errorProperties.includes("住所３"))
    setIsInvalid郵便番号(errorProperties.includes("郵便番号"))
    setIsInvalid電話番号(errorProperties.includes("電話番号"))
    setIsInvalidFAX番号(errorProperties.includes("FAX番号"))
    setIsInvalid積卸先担当者(errorProperties.includes("積卸先担当者"))
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (荷主コード == null || 積卸先コード == null || 積卸先名 == null) return

      const service = new TumiorosisakiService()
      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getPutReq())
      } else {
        res = await service.post(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`積卸先マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 削除
   */
  const doDelete = async () => {
    try {
      const service = new TumiorosisakiService()
      const res: TApiResponse<boolean> = await service.delete(id!, {
        更新日時: 最終更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`積卸先マスタを削除しました`)
      }
    } catch (error) {
      const errRes = error as TApiResponse<boolean>

      //DW23503：使用済エラーの場合、廃止年月の入力を促す
      const 制約エラー = errRes?.warns?.find(
        (w) => w.code === CONSTANT.制約エラーコード
      )
      if (制約エラー) {
        const warnErrorMessage = [
          制約エラー.messageWithCode,
          "新規利用を停止したい場合、廃止ボタンを押下してください。",
        ]
        set廃止ボタン表示フラグ(true)
        disPatch(setWarningAlerts(warnErrorMessage))
      } else {
        disPatch(setAlerts(error))
      }
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  /**
   * 廃止
   */
  const doHaisi = async () => {
    try {
      const service = new TumiorosisakiService()
      const res: TApiResponse<boolean> = await service.haisi(id!, {
        更新日時: 最終更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`積卸先マスタを廃止しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmHaisiModalShow(false)
    }
  }

  /**
   * 廃止
   */
  const doHaisiKaizyo = async () => {
    try {
      const service = new TumiorosisakiService()
      const res: TApiResponse<boolean> = await service.haisiKaizyo(id!, {
        更新日時: 最終更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`積卸先マスタを復活しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmHaisiModalShow(false)
    }
  }

  const update荷主 = async (荷主コード: string) => {
    set荷主名("")

    if (荷主コード == null || wjCore.isNullOrWhiteSpace(荷主コード)) return

    try {
      const res = await new NinusiService().getList({
        荷主コード: 荷主コード,
        完全一致フラグ: true,
      })

      if (res.data.length === 1) set荷主名(res.data[0].荷主名)
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    const abortController = new AbortController()

    Promise.all([new TodohukenService().getList()]).then(([都道府県Res]) => {
      set都道府県ItemSource(都道府県Res.data)
      // id存在時はデータを取得し更新
      if (id) {
        getData(id, abortController.signal).finally(() => {
          disPatch(画面ロック解除())
          // ファイルロード後、戻るボタン押下時に警告が出るように変更
          isPrompt.current = !読取専用フラグ
        })
      } else {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      }
    })

    return () => {
      abortController.abort()
    }
  }, [])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">
              積卸先マスタ{id ? `更新` : `登録`}
            </span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-70rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 荷主 */}
                  <MasterRegisterFormRow label="荷主" isRequired={true}>
                    <TextInput
                      autoFocus={true}
                      style={{ width: "6rem" }}
                      id="荷主コード"
                      name="荷主コード"
                      placeholder="荷主CD"
                      isReadOnly={id != null}
                      maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                      value={荷主コード}
                      setValue={(v) => {
                        set荷主コード(v)
                      }}
                      className={isInvalid荷主コード ? "is-error" : ""}
                      onBlur={(e) => {
                        id == null && update荷主(荷主コード ?? "")
                      }}></TextInput>
                    {id == null && (
                      <button
                        type="button"
                        className="icon-button"
                        onClick={() => {
                          setIs荷主検索Modal(true)
                        }}>
                        <FontAwesomeIcon
                          className="icon-button-inner"
                          icon={faSearch}
                        />
                      </button>
                    )}
                    <TextInput
                      style={{ width: "30rem" }}
                      id="荷主名"
                      name="荷主名"
                      placeholder="荷主名"
                      isReadOnly={true}
                      maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                      value={荷主名}
                      setValue={(v) => {
                        set荷主名(v)
                      }}></TextInput>
                  </MasterRegisterFormRow>
                  {/* 積卸先コード */}
                  <MasterRegisterFormRow
                    label="積卸先コード"
                    isRequired={true}
                    remarks={
                      <div>
                        半角英数字10桁まで
                        <br />
                        荷主内で重複しないコードを設定
                      </div>
                    }>
                    <TextInput
                      id="積卸先コード"
                      name="積卸先コード"
                      value={積卸先コード}
                      isReadOnly={id != null}
                      maxLength={VALIDATE_CONSTANT.LENGTH.積卸先コード}
                      setValue={set積卸先コード}
                      className={isInvalid積卸先コード ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 社名 */}
                  <div className="register-form-row">
                    <div
                      className="register-form-item"
                      style={{ width: "calc(100% - 19rem)" }}>
                      <div className="register-form-label">
                        <label htmlFor={"社名"}>
                          社名
                          <RequiredMark />
                        </label>
                      </div>
                      <div className={`register-form-value w-100`}>
                        <Spinner searching={isSearching}></Spinner>
                        <div className="w-100">
                          <div
                            className="max-w-30rem"
                            style={{ width: " 195px" }}>
                            <TextInput
                              style={{ width: "30rem" }}
                              id="積卸先名"
                              name="積卸先名"
                              value={積卸先名}
                              setValue={set積卸先名}
                              maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                              onBlur={(e) => {
                                // 新規登録時のみ
                                if (id != null) return
                                if (
                                  積卸先名カナ == null ||
                                  wjCore.isNullOrWhiteSpace(積卸先名カナ)
                                ) {
                                  set積卸先名カナ(e.target.value)
                                }
                                if (
                                  積卸先略称 == null ||
                                  wjCore.isNullOrWhiteSpace(積卸先略称)
                                ) {
                                  set積卸先略称(e.target.value)
                                }
                              }}
                              onChange={(e) => {
                                search(e.target.value)
                              }}
                              className={isInvalid積卸先名 ? "is-error" : ""}
                            />
                          </div>
                          {積卸先名称確認List.length > 0 && (
                            <div className="max-w-35rem max-h-6rem m-1 overflow-auto">
                              <ul>
                                {積卸先名称確認List.map((積卸先, index) => {
                                  return (
                                    <li
                                      className={
                                        "mx-1 text-danger text-decoration-underline"
                                      }>
                                      <OverlayTrigger
                                        key={積卸先.積卸先ID}
                                        placement={"right"}
                                        overlay={
                                          <Tooltip>
                                            <div>荷主:{積卸先.荷主名}</div>
                                            {積卸先.電話番号 && (
                                              <div>
                                                電話番号:{積卸先.電話番号}
                                              </div>
                                            )}
                                          </Tooltip>
                                        }>
                                        <span>
                                          {積卸先.積卸先コード}:
                                          {!wjCore.isNullOrWhiteSpace(
                                            積卸先.積卸先略称
                                          )
                                            ? 積卸先.積卸先略称
                                            : 積卸先.積卸先名}{" "}
                                          {積卸先.郵便番号} {積卸先.住所１}
                                          {積卸先.住所２}
                                          {積卸先.住所３}
                                        </span>
                                      </OverlayTrigger>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="register-form-remarks">
                      {積卸先名称確認List.length > 0 && (
                        <div className="text-danger fw-bold">
                          <div>
                            ※社名が一部一致する積卸先が存在します。一覧より重複登録がないか確認してください。
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* 社名カナ */}
                  <MasterRegisterFormRow label="社名カナ">
                    <TextInput
                      style={{ width: "30rem" }}
                      id="積卸先名カナ"
                      name="積卸先名カナ"
                      value={積卸先名カナ}
                      setValue={set積卸先名カナ}
                      maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                      className={isInvalid積卸先名カナ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 社名略称 */}
                  <MasterRegisterFormRow
                    label="社名略称"
                    remarks={<div>請求書のコース編集名に表示</div>}>
                    <TextInput
                      id="積卸先名略称"
                      name="積卸先名略称"
                      value={積卸先略称}
                      setValue={set積卸先略称}
                      maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                      className={isInvalid積卸先略称 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 住所１ */}
                  <MasterRegisterFormRow label="都道府県" isRequired={false}>
                    <ComboBox.Todohuken
                      itemsSource={都道府県ItemSource}
                      isLoadEnded={都道府県isLoadEnded}
                      setIsLoadEnded={set都道府県isLoadEnded}
                      selectedValue={都道府県コード}
                      setSelectedValue={set都道府県コード}
                      setSelectedItem={set都道府県}
                      isRequired={true}
                      isEmpty={true}
                      className={isInvalid都道府県コード ? "is-error" : ""}
                      ComboBox={都道府県ComboBox}
                      setComboBox={set都道府県ComboBox}></ComboBox.Todohuken>
                  </MasterRegisterFormRow>
                  {/* 住所２ */}
                  <MasterRegisterFormRow label="市区町村" isRequired={false}>
                    <div className="w-13rem">
                      <TextInput
                        id="住所2"
                        name="住所2"
                        value={住所２}
                        setValue={set住所2}
                        className={isInvalid住所2 ? "is-error" : ""}
                        placeholder="市区町村"
                      />
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault()
                        setIs市区町村ModalShow(true)
                      }}
                      className="icon-button">
                      <FontAwesomeIcon
                        className="icon-button-inner"
                        icon={faSearch}></FontAwesomeIcon>
                    </button>
                  </MasterRegisterFormRow>
                  {/* 住所３ */}
                  <MasterRegisterFormRow label="町名番地">
                    <div className="w-15rem">
                      <TextInput
                        style={{ width: "30rem" }}
                        id="住所３"
                        name="住所３"
                        value={住所３}
                        setValue={set住所3}
                        maxLength={VALIDATE_CONSTANT.LENGTH.住所３}
                        className={isInvalid住所3 ? "is-error" : ""}
                        placeholder="町名番地"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 郵便番号 */}
                  <MasterRegisterFormRow label="郵便番号">
                    <div className="w-15rem">
                      <TextInput
                        id="郵便番号"
                        name="郵便番号"
                        value={郵便番号}
                        setValue={set郵便番号}
                        maxLength={VALIDATE_CONSTANT.LENGTH.郵便番号}
                        className={isInvalid郵便番号 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 電話番号 */}
                  <MasterRegisterFormRow label="電話番号">
                    <div className="w-15rem">
                      <TextInput
                        id="電話番号"
                        name="電話番号"
                        value={電話番号}
                        setValue={set電話番号}
                        type={"tel"}
                        className={isInvalid電話番号 ? "is-error" : ""}
                        maxLength={VALIDATE_CONSTANT.LENGTH.電話番号}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* FAX番号 */}
                  <MasterRegisterFormRow label="FAX番号">
                    <div className="w-15rem">
                      <TextInput
                        id="FAX番号"
                        name="FAX番号"
                        value={FAX番号}
                        setValue={setFAX番号}
                        type={"tel"}
                        className={isInvalidFAX番号 ? "is-error" : ""}
                        maxLength={VALIDATE_CONSTANT.LENGTH.電話番号}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 積卸先担当者 */}
                  <MasterRegisterFormRow label="積卸先担当者">
                    <div className="w-15rem">
                      <TextInput
                        id="積卸先担当者"
                        name="積卸先担当者"
                        value={積卸先担当者}
                        setValue={set積卸先担当者}
                        className={isInvalid積卸先担当者 ? "is-error" : ""}
                        maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                      />
                    </div>
                  </MasterRegisterFormRow>

                  {/* 客先台帳 */}
                  <MasterRegisterFormRow
                    label="客先台帳"
                    remarks={
                      <div className="align-middle">
                        {新規客先台帳ファイル && (
                          <Button
                            type="button"
                            className="btn btn-small btn-upload"
                            variant="danger"
                            onClick={newFileDelete}>
                            ファイル選択を解除する
                          </Button>
                        )}
                      </div>
                    }>
                    <div className="d-flex">
                      {客先台帳ファイルURL && 新規客先台帳ファイル == null ? (
                        <div className="floating-frame">
                          <div className="wj-control wj-content wj-dropdown">
                            <div className="wj-template">
                              <div className="wj-input">
                                <div className="wj-input-group">
                                  <div className="wj-form-control wj-form-content text-input w-15rem read-only">
                                    <a
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={客先台帳ファイルURL}
                                      onClick={(e) => {
                                        e.preventDefault()
                                        const service = new ContentService()
                                        service
                                          .get(客先台帳ファイルURL)
                                          .then((blob) => {
                                            saveAs(blob, 客先台帳ファイル名)
                                          })
                                          .catch((err) =>
                                            disPatch(setAlerts(err))
                                          )
                                      }}>
                                      {客先台帳ファイル名}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <TextInput
                          id="新規客先台帳ファイル名"
                          name="新規客先台帳ファイル名"
                          value={新規客先台帳ファイル名}
                          setValue={set新規客先台帳ファイル名}
                          isReadOnly
                          className={
                            isInvalid客先台帳 ? "is-error w-15rem" : " w-15rem"
                          }
                          maxLength={100}
                        />
                      )}
                      <Button
                        type="submit"
                        className="btn btn-small btn-upload ms-2"
                        variant="done"
                        onClick={fileUpload}>
                        ファイル選択
                      </Button>
                      <input
                        type="file"
                        hidden
                        accept=".pdf"
                        ref={refFileInput}
                        onChange={onFileInputChange}
                      />
                    </div>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
            {廃止日 && (
              <Row>
                <Col>
                  廃止日 : {util.date.format(廃止日, "YYYY/MM/DD HH:mm:ss")}
                </Col>
              </Row>
            )}
          </>
        )}
        <Row className="search-button">
          <Col>
            {!読取専用フラグ && (
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            )}
            <Button
              size="lg"
              className="ms-2"
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
            {!読取専用フラグ && (
              <>
                {wjCore.isNullOrWhiteSpace(廃止日 ?? "") && (
                  <Button
                    size="lg"
                    className="ms-5"
                    variant="caution"
                    disabled={!id || 廃止ボタン表示フラグ}
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      beforeDeleteSubmit()
                    }}>
                    削除
                  </Button>
                )}
                {廃止ボタン表示フラグ && (
                  <Button
                    size="lg"
                    className="ms-5"
                    variant="caution"
                    disabled={!id}
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      beforeHaisiSubmit()
                    }}>
                    廃止
                  </Button>
                )}
                {!wjCore.isNullOrWhiteSpace(廃止日 ?? "") && (
                  <Button
                    size="lg"
                    className="ms-5"
                    variant="caution"
                    disabled={!id}
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      beforeHaisiKaizyoSubmit()
                    }}>
                    廃止解除
                  </Button>
                )}
              </>
            )}
          </Col>
        </Row>
      </Container>
      <SikutyosonSearchModal
        isShow={is市区町村ModalShow}
        setIsShow={setIs市区町村ModalShow}
        setData={set市区町村}
        todohuken={都道府県?.都道府県名漢字 ?? ""}
        is市区町村のみ={true}></SikutyosonSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={doDelete}>
        積卸先マスタを削除しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmHaisiModalShow}
        hideHandler={setIsConfirmHaisiModalShow}
        submitHandler={doHaisi}>
        積卸先マスタを廃止しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmHaisiKaizyoModalShow}
        hideHandler={setIsConfirmHaisiKaizyoModalShow}
        submitHandler={doHaisiKaizyo}>
        積卸先マスタを廃止解除しますか？ 積卸先を再度登録できるようになります。
      </ConfirmModal>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主名)
        }}></NinusiSearchModal>
    </>
  )
}

export default MasterTumiorosisakiRegister
